import { createFileRoute } from '@tanstack/react-router';
import { GenerationResult } from '../../../../features/doc-generation/BulkGeneration';
export const Route = createFileRoute('/_app/documents/generated/$jobId')({ component: GeneratedDocuments });
function GeneratedDocuments() {
  const { jobId } = Route.useParams();
  return (
    <main className="dg-result-page">
      <GenerationResult id={jobId} />
    </main>
  );
}
